import React from "react";
import { useNavigate } from "react-router-dom";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import NewsFeedFilterForm from "./forms/NewsFeedFilterForm";
import { NewsFeed } from "./Newsfeed";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";


function NewsFeedWrapper() {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-newsfeed`;
        navigate(path);
    }

     return (
          <>
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="News Feed">
                    <CreateButton name="Create News Feed" onClick={handleData} />
               </MainLeftTitle>
                    <UiAccordian>
                         <SearchBarWr>
                              <NewsFeedFilterForm/>
                         </SearchBarWr>
                    </UiAccordian>
               <NewsFeed />
          </div>
          </>
     );
}

export default NewsFeedWrapper;